import type { CreateTextPostPayload } from '@fourthwall/services/dist/MembershipsCreatorApiClient'

import type { FormValues } from '../../types'
import { getCommonFieldsPayload } from './getCommonFieldsPayload'

export const getTextPostPayload = (values: FormValues): CreateTextPostPayload => {
  return getCommonFieldsPayload(values)
}
